// extracted by mini-css-extract-plugin
module.exports = {"labelsTableInner":"LabelsTable_labelsTableInner__2eWr7","labelsTable":"LabelsTable_labelsTable__iuSpe"};